import { render, staticRenderFns } from "./ParticipantTable.vue?vue&type=template&id=120f2a8e&"
import script from "./ParticipantTable.vue?vue&type=script&lang=js&"
export * from "./ParticipantTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports